import { Sparkle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { ACCOLADES, IMAGES } from "@/lib/site";

export default function Accolades() {
  return (
    <section id="accolades" className="py-28 lg:py-36 relative overflow-hidden" data-testid="accolades-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-16 items-center">
        <div>
          <Reveal>
            <p className="text-fuchsia tracking-[0.35em] uppercase text-xs font-semibold mb-6">Winner Accolades</p>
          </Reveal>
          <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl" data-testid="accolades-heading">
            <Reveal delay={0.1}><span className="block">YOUR MOMENT.</span></Reveal>
            <Reveal delay={0.2}><span className="block gold-text">YOUR TITLE.</span></Reveal>
            <Reveal delay={0.3}><span className="block">YOUR SPOTLIGHT.</span></Reveal>
          </h2>
          <Reveal delay={0.4}>
            <div className="relative mt-12 max-w-sm">
              <div className="absolute -inset-6 bg-gold/10 blur-3xl rounded-full" />
              <img
                src={IMAGES.crown}
                alt="The grand golden winner's crown of HA Treasure House"
                className="relative w-full h-72 object-cover rounded-sm gold-frame animate-float"
                data-testid="accolades-crown-image"
              />
            </div>
          </Reveal>
        </div>

        <ul className="space-y-0" data-testid="accolades-list">
          {ACCOLADES.map((a, i) => (
            <Reveal key={a} delay={0.06 * i}>
              <li className="group flex items-center gap-5 border-b border-gold/15 py-5 transition-colors duration-300 hover:border-gold/40" data-testid={`accolade-item-${i}`}>
                <span className="font-display text-sm text-gold/60 w-8">{String(i + 1).padStart(2, "0")}</span>
                <Sparkle size={16} className="text-gold shrink-0 transition-transform duration-500 group-hover:scale-125" />
                <span className="font-display text-xl sm:text-2xl text-cream/90 group-hover:text-gold-light transition-colors duration-300">{a}</span>
              </li>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
